/**
 * Layout component 
 */

import React from "react"
import PropTypes from "prop-types"

import Header from "../header"
import Footer from "../footer"
import SEO from "../seo"
import Navigation from "../navigation"

import styles from "./layout.module.css"
import "./layout.css"

const Layout = ({ children, navigation }) => {

  return (
    <>
      <SEO title="Home" />
      <Header navigation={navigation?navigation:<DefaultPageNavigation />} />
      <div className={`container ${styles.container}`}>
        <main>{children}</main>
        <Footer />
      </div>
    </>
  )
}

const DefaultPageNavigation = () => <Navigation 
type="hamburger"
items={[
  {
    title: "Home",
    url: "/events/sf-cybertalks/",
},
    {
        title: "About",
        url: "/events/sf-cybertalks/#about",
    },
    {
        title: "Sponsor",
        url: "/events/sf-cybertalks/#Sponsors",
    },
    {
        title: "Speakers",
        url: "/events/sf-cybertalks/#Speakers",
    },
    {
        title: "Agenda",
        url: "/events/sf-cybertalks/#Agenda",
    },
    {
        title: "Venue",
        url: "/events/sf-cybertalks/#venue",
    },
    {
      title: "Wrap-up",
      url: "/events/sf-cybertalks/wrap-up",
  },
]}
/>
Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
